module.exports = __webpack_public_path__ + "static/img/box-close.dbbfde40.png";